import "./dialog.scss";
import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const ConfirmDialog = ({ open, onClose, onConfirm, nameData }) => {
  return (
    <Dialog open={open} onClose={onClose} className="dialog">
      <DialogTitle className="dialog-title">
        <span className="dialog-warning-icon">⚠️</span>
      </DialogTitle>
      <DialogContent className="dialog-content">
        ¿Estás seguro de que deseas eliminar este {nameData}? Esta acción no se puede deshacer.
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancelar
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error">
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
